<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(e) => $emit('checkbox-change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import PageHeader from './header'
import PageMain from './table.vue'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader },
  props: { amzReplenishmentCode: { type: String, default: '' } },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzReplenishmentDetailOptionsApi({
          amzReplenishmentCode: this.amzReplenishmentCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.$refs.main.clearCheckboxRow()
    },
  },
}
</script>
